import * as React from "react";
import ToggleButton from "../commons/components/buttons/ToggleButton";

interface HeaderWithToggleProps {
  title: string;
  active?: boolean;
  onChange?: (boolean) => void;
}

export default function HeaderWithToggle({ title, active, onChange }: HeaderWithToggleProps) {
  const toggleActivation = () => {
    onChange(!active);
  };

  return (
    <div className="h-flex space-between">
      <h2 className="setting-title">{title}</h2>
      <div className="actions">
        {active !== undefined && <ToggleButton value={active} onChange={toggleActivation} />}
      </div>
    </div>
  );
}
